module.exports = __webpack_public_path__ + "media/images/icons/house_rules/no-smoking-9566f3f90d5bb115c4c6a8cdfc452270.svg";